const lang = {
  paid_plan_application: '有料アカウント申込み',
  customer_information: 'お客様情報',
  company_name: '会社名',
  postal_code: '郵便番号',
  street_address: '住所',
  representative_name: '代表者名',
  person_in_charge: 'ご担当者名',
  department_name: '部署名',
  building_name: '建物名',
  required: ' ※必須',
  email: 'E-mail',
  agree_and_continue: '同意して次へ'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/customerInformation.js